/**
 * Klima (AC) systems are sold as two line items (inner + outer) in the app,
 * but Mars prices represent the full set on the outdoor unit SKU only.
 * For Mars-based profit, inner units carry zero cost.
 */
export function isKlimaInnerUnit(productName: string | null | undefined): boolean {
  return (productName ?? '').includes('İÇ ÜNİTE');
}

export function isKlimaOuterUnit(productName: string | null | undefined): boolean {
  return (productName ?? '').includes('DIŞ ÜNİTE');
}

/**
 * Mars cost for profit calculation when Mars pricing is enabled.
 * Inner evaporator units: 0 (cost is on the paired outdoor unit's Mars price).
 */
export function getKlimaMarsUnitCost(
  productName: string | null | undefined,
  marsPrice: number | null | undefined,
  fallbackCost: number
): number {
  if (isKlimaInnerUnit(productName)) {
    return 0;
  }

  if (marsPrice !== null && marsPrice !== undefined) {
    return marsPrice;
  }

  return fallbackCost;
}
